import AScene from "../../library/ExtendedObjects/AScene.js";
import Backgrounds from "../Backgrounds.js";
import gameData from "../../gameData.js";
import Game_PigAnimations from "./Game_PigAnimations.js";
import GameMenu from "../GameMenu.js";
import Dollar from "./Dollar.js";
import Game_ProgressBar from "./Game_ProgressBar.js";
import Coin from "./Coin.js";

export default class Game extends AScene
{
    create()
    {
        this.background = new Backgrounds(this);
        this.background.displayBG(gameData.backgroundClasses[gameData.curBackground], false);
        this.background.hideBG(gameData.backgroundClasses[gameData.curBackground]);

        this.pigAnimations = new Game_PigAnimations(this);
        this.menu = new GameMenu(this, false);
        this.progressBar = new Game_ProgressBar(this, 1100, 180);

        this.hitArea = this.addRect(200, 150, 660, 400, 0xff0000, this, true, ()=>{
            if(!this.canHammer) return;
            this.hammerPig();
        }, "pointerdown", false);
        this.hitArea.setDepth(0);

        this.canHammer = false;
        this.cracks = null;
        this.timesHammered = 0;
        this.totalValue = 0;
        this.money = [];

        this.activeRegion = this.addRect(0, 0, 910, 575).setAlpha(0);
        this.menuRegion = this.addRect(0, 0, 84, 84).setAlpha(0);

        this.collide_group = this.matter.world.nextGroup();
        this.noCollide_group = this.matter.world.nextGroup();
        this.collide_cat = this.matter.world.nextCategory();
        this.noCollide_cat = this.matter.world.nextCategory();
        this.matter.add.mouseSpring({ length: 0, stiffness: .9, collisionFilter: { group: this.noCollide_group } });

        this.dollarEmitter = this.addEmitter({
            speed: 50,
            x: this.mid.x, y: this.mid.y,
            scale: {min: .07, max: .15},
            quantity: 5,
            tint: [0xeef9e4, 0xeef9e4, 0x2c3a10],
            alpha: {start: 1, end: 0},
            emitZone: { type: "random", source: new Phaser.Geom.Rectangle(0, 0, 365, 152)}
        }, "particle");
        this.dollarEmitter.stop().manager.setDepth(3);

        this.silverEmitter = this.addEmitter({
            speed: 50,
            x: this.mid.x, y: this.mid.y,
            scale: {min: .07, max: .15},
            quantity: 5,
            tint: [0xeeeff3, 0xeeeff3, 0xc5c8d0],
            alpha: {start: 1, end: 0},
            emitZone: { type: "random", source: new Phaser.Geom.Circle(0, 0, 40)}
        }, "particle");
        this.silverEmitter.stop().manager.setDepth(3);

        this.copperEmitter = this.addEmitter({
            speed: 50,
            x: this.mid.x, y: this.mid.y,
            scale: {min: .07, max: .15},
            quantity: 5,
            tint: [0xf2bea7, 0xf2bea7, 0xaf705b],
            alpha: {start: 1, end: 0},
            emitZone: { type: "random", source: new Phaser.Geom.Circle(0, 0, 40)}
        }, "particle");
        this.copperEmitter.stop().manager.setDepth(3);

        this.instructionsGroup = this.add.container(this.mid.x, 660).setAlpha(0);
        this.addRect(-this.mid.x, -70, this.size.width, 140, 0x000, this.instructionsGroup).setAlpha(.3);
        this.addText(0, 0, 45, 0xffffff, gameData.fonts.comfortaa_bold, "CLICK ON THE PIGGY BANK\nTO BREAK IT OPEN!", this.instructionsGroup)

        this.animatePig();
    }

    killAllMoney()
    {
        for(let i = 0; i < this.money.length; i++)
        {
            let money = this.money[i];
            this.addDelay(i * 100, ()=>{
                this.killMoney(money);
            });
        }
        this.addDelay(this.money.length * 50, ()=>{
            while(this.money.length > 0)
            {
                this.money.pop();
            }
        });
    }

    killMoney(money)
    {
        if (money instanceof Coin) {
            this.copperEmitter.emitZone.source.radius = 40 * money.scaleX;

            if (money.animation == "pennyAnim") this.copperEmitter.explode(100, money.x, money.y);
            else this.silverEmitter.explode(100, money.x, money.y);
        }
        else {
            this.dollarEmitter.emitZone.source.width = 365 * money.scaleX;
            this.dollarEmitter.emitZone.source.height = 152 * money.scaleX;
            this.dollarEmitter.explode(200, money.x - money.width * .5 * money.scaleX, money.y - money.height * .5 * money.scaleX);
        }
        this.shadowObjects.splice(this.shadowObjects.indexOf(money), 1);

        this.money.splice(this.money.indexOf(money), 1);

        money.shadow.destroy();
        money.setVisible(false);

        return this.money.length == 0;
    }

    hammerPig()
    {
        if(this.timesHammered >= 4) return;
        else if(this.timesHammered == 0)
        {
            this.killTween(this.instructionsGroup);
            this.addTween(this.instructionsGroup, 200, {alpha: 0});
        }

        let hammer = this.addSprite(this.mid.x, this.mid.y, "hammerAnim");
        hammer.anims.stop();
        hammer.setDepth(5);
        hammer.anims.play("hammerAnim");

        this.playSound("hit_bank");

        this.timesHammered++;
        let crackCount = this.timesHammered;

        let mod = this.timesHammered%2 == 0 ? -1 : 1;
        hammer.setScale(mod * 3, 3);

        this.addTween(hammer, 300, {scaleX: 1.5 * mod, scaleY: 1.5, x: this.input.x + (120 * mod), y: this.input.y - 120}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.addTween(hammer, 200, {alpha: 0, delay: 150}, Phaser.Math.Easing.Sine.Out, ()=>{
                hammer.destroy();
            });

            this.cracks.alpha = this.cracks.crackAlpha;
            
            if(crackCount >= 4)
            {
                this.explodePig();
            }
            else 
            {
                this.cameras.main.shake(100, .005);
                this.cracks.setFrame("Crks_" + crackCount);
            }
        });
    }

    explodePig()
    {
        this.playSound("smash_bank");

        let explosionSprite = this.addSprite(this.mid.x, this.mid.y - 20, "explosionAnim").setDepth(4);
        explosionSprite.on('animationcomplete', ()=>{
            explosionSprite.destroy();
        });
        explosionSprite.addListenerToFrame(9, ()=>{
            if(this.pigMask) this.pigMask.destroy();
            if(this.pigMask) this.cracks.destroy();
            this.pig.destroy();
            this.addTween(this.progressBar, 300, {alpha: 1});
            this.addTween(this.progressBar, 1100, {x: 950, easeParams: [.9, .9]}, "Elastic");
            this.spawnMoney();
            this.pigExploded();
        });

        this.cameras.main.shake(200, .008);
        this.addTween([this.pig.spine, this.cracks], 40, {x: this.pig.spine.x - 30, repeat: -1, yoyo: true}, Phaser.Math.Easing.Sine.InOut);
    }

    pigExploded() {} //Overridden

    answerCorrect()
    {
        this.killAllMoney();
        this.progressBar.incrementProgress();
        this.playSound("correct_answer");

        this.addDelay(1000, ()=>{
            let isComplete = gameData.curProgress >= gameData.numOfLevels;
            if (isComplete) {
                this.addTween(this.progressBar, 300, { alpha: 0, x: 1100 }, null, () => {
                    this.displayCompleteScreen();
                });
                this.addTween(this.menu.menuBtn, 300, {scaleX: 0, scaleY: 0});
            }
            else {
                this.addTween(this.progressBar, 300, { alpha: 0, x: 1100 }, null, () => {
                    this.scene.start(this.scene.key);
                });
            }
            
        });
    }

    displayCompleteScreen()
    {
        this.playSound("great_job");
        this.completeTitle = this.addImage(this.mid.x, this.mid.y - 100, "GreatJob");
        this.completeTitle.setScale(.4);
        this.completeTitle.setAlpha(0);
        this.addTween(this.completeTitle, 700, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
        this.addTween(this.completeTitle, 400, {y: this.mid.y}, Phaser.Math.Easing.Sine.Out);
        this.addTween(this.completeTitle, 2200, {scaleX: 1, scaleY: 1, easeParams: [.9, .6]}, "Elastic", ()=>{
            this.addTween(this.completeTitle, 500, {scaleX: 1.4, scaleY: 1.4, alpha: 0}, Phaser.Math.Easing.Sine.In, ()=>{
                this.scene.start("Bonus");
            });
        });
    }

    spawnMoney()
    {
        let billSpawns = gameData.denominations == gameData.denominationTypes.DOLLARS ? Phaser.Math.Between(4, 6) : Phaser.Math.Between(2, 4);
        let coinSpawns = gameData.denominations == gameData.denominationTypes.COINS ? Phaser.Math.Between(8, 12) : Phaser.Math.Between(6, 8);
        let billKeys = Object.keys(gameData.dollarData);
        let coinKeys = Object.keys(gameData.coinData)

        let bill = new Dollar(this, this.mid.x, 100, gameData.dollarData[1]).setAlpha(0);
        let minX = bill.minX + 100;
        let xDiff = bill.maxX - minX;
        let yDiff = bill.maxY - bill.minY;
        let billdestinations = [];
        for(let y = 0; y < 3; y++)
        {
            for (let x = 0; x < 2; x++) 
            {
                let deltaX = x/1
                let deltaY = y/2;
                billdestinations.push({x: minX + (deltaX * xDiff), y: bill.minY + (deltaY * yDiff)})
            }
        }
        bill.destroy();

        if (gameData.denominations == gameData.denominationTypes.COINS_DOLLARS || gameData.denominations == gameData.denominationTypes.COINS) {
            for (let i = 0; i < coinSpawns; i++) {
                let coinData = gameData.coinData[coinKeys[Phaser.Math.Between(0, coinKeys.length - 1)]];
                if(gameData.denominations == gameData.denominationTypes.COINS_DOLLARS && (this.totalValue + coinData.value) >= 1) break;
                
                let coin = new Coin(this, this.mid.x, 100, coinData).setPosition(this.mid.x, this.mid.y).setScale(coinData.scale);

                this.addTween(coin, 200, { x: Phaser.Math.Between(coin.minX, coin.maxX), y: Phaser.Math.Between(coin.minY, coin.maxY) }, Phaser.Math.Easing.Sine.Out);
                this.addDropShadow(coin, 3, 3, coinData.sprite);
                this.addDelay(i*10 + 40, ()=>{ coin.setDepth(3).shadow.setDepth(3); });

                this.money.push(coin);
                this.totalValue += coinData.value;
            }
        }

        if (gameData.denominations == gameData.denominationTypes.COINS_DOLLARS || gameData.denominations == gameData.denominationTypes.DOLLARS) {
            for (let i = 0; i < billSpawns; i++) {
                let billData = gameData.dollarData[billKeys[Phaser.Math.Between(0, billKeys.length - 1)]];
                let bill = new Dollar(this, this.mid.x, 100, billData).setPosition(this.mid.x, this.mid.y).setScale(1);

                this.addDropShadow(bill, 5, 5, billData.sprite);
                this.addTween(bill, 200, { x: billdestinations[i].x, y: billdestinations[i].y }, Phaser.Math.Easing.Sine.Out);
                this.addDelay(i*10 + 40, ()=>{ bill.setDepth(2).shadow.setDepth(2); });

                this.money.push(bill);
                this.totalValue += billData.value;
            }
        }

        this.totalValue = this.totalValue.toFixed(2);
    }

    animatePig()
    {
        let pigs = Object.keys(gameData.pigs);
        let randIdx = 0;
        if (gameData.pigType == -1) {
            gameData.usedPigs.forEach((pigKey) => {
                pigs.splice(pigs.indexOf(pigKey), 1);
            });
            if (pigs.length == 0) {
                gameData.usedPigs = [];
                pigs = Object.keys(gameData.pigs);
            }
            randIdx = Phaser.Math.Between(0, pigs.length - 1);
        }
        else randIdx = gameData.pigType;
        let pigKey = pigs[randIdx];
        let pigData = gameData.pigs[pigKey];
        gameData.usedPigs.push(pigKey);
        
        this.pig = this.addSpine(this.mid.x, this.mid.y, "Pig", "GoldPig");
        this.pig.addDropShadow(20, 20, .2);

        if(pigData.introDelay) this.addDelay(pigData.introDelay, ()=>{this.playSound(pigData.introSound);});
        else this.playSound(pigData.introSound);
        
        gameData.curBackground = pigData.bg;
        this.addDelay(500, ()=>{this.background.displayBG(gameData.backgroundClasses[pigData.bg], true);});
        
        this.pigAnimations.playAnimation(pigKey, this.pig, () => {
            this.animationComplete(pigData);
        });
    }

    animationComplete(pigData)
    {
        this.pigMask = this.addImage(this.mid.x + pigData.maskOffset.x, this.mid.y + pigData.maskOffset.y, pigData.crackMask, null, "pigMasks");
        this.pigMask.setVisible(false);

        this.cracks = this.addImage(this.pigMask.x, this.pigMask.y, "Crks_1");
        this.cracks.crackAlpha = 1;
        this.cracks.setDepth(1);
        this.cracks.mask = new Phaser.Display.Masks.BitmapMask(this, this.pigMask);
        this.cracks.setAlpha(0);

        this.canHammer = true;
        this.addTween(this.instructionsGroup, 500, {alpha: 1});
        if(pigData.bg == "ninjaBG") this.cracks.setTintFill(0xffffff).crackAlpha = .7;
    }
}